module.exports = __webpack_public_path__ + "static/img/yiwanjie.447df93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/yiwanjie.png
// module id = c4wH
// module chunks = 0